import React from "react";
import { Navigate } from "react-router-dom";

// Dashboard
import Widgets from "../pages/Dashboard/Index";

// Authentication pages
import Basic404 from "../pages/Authentication/Basic404.js";
import Login from "../pages/Authentication/Login";
import ForgetPasswordPage from "../pages/Authentication/ForgetPassword";
import Logout from "../pages/Authentication/Logout";
import ResetPasswordForm from "../pages/Authentication/ResetPassword.js";
import UserProfile from "../pages/Authentication/userProfile.js";

// Users page
import Users from "../pages/Users/Index";

// Farmhouse pages
import FarmhouseList from "../pages/Farmhouse/index";

// Bookings page (single entry) - handled as modal/dialogs inside the page
import Bookings from "../pages/Bookings/Index";
import BookingSheet from "../pages/Bookings/BookingSheet";

// Static Pages
import HouseRules from "../pages/StaticPages/HouseRules";
import PrivacyPolicy from "../pages/StaticPages/PrivacyPolicy";
import TermsAndCondition from "../pages/StaticPages/TermsAndCondition";
import CancellationPolicy from "../pages/StaticPages/CancellationPolicy";

// Settings
import Settings from "../pages/Settings/Index";

import InvoiceView from "../pages/Bookings/InvoiceView";

const authProtectedRoutes = [
  // Dashboard
  { path: "/dashboard", component: <Widgets /> },
  // Other pages
  {
    path: "/",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },
  { path: "*", component: <Navigate to="/404" /> },

  // Profile
  { path: "/profile", component: <UserProfile /> },

  // Users
  { path: "/users", component: <Users /> },

  // Bookings (single route only; create/edit/details are dialogs inside the page)
  { path: "/bookings", component: <Bookings /> },
  { path: "/booking-sheet", component: <BookingSheet /> },

  // Farmhouse
  { path: "/farmhouses", component: <FarmhouseList /> },

  // Static Pages - Individual Routes
  { path: "/house-rules", component: <HouseRules /> },
  { path: "/privacy-policy", component: <PrivacyPolicy /> },
  { path: "/terms-condition", component: <TermsAndCondition /> },
  { path: "/cancellation-policy", component: <CancellationPolicy /> },

  // Settings
  { path: "/settings", component: <Settings /> },
];

const publicRoutes = [
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPasswordPage /> },
  { path: "/reset-password", component: <ResetPasswordForm /> },
  { path: "/404", component: <Basic404 /> },
  { path: "/invoice/:id", component: <InvoiceView /> },
];

export { authProtectedRoutes, publicRoutes };
